<template>
    <!-- 登录 -->
    <div>
      <div v-show="loginFlag" style="width: 100%;height: 100%;position: absolute">
        <div style="height: 400px;width: 300px;margin-left: auto;margin-right: auto;margin-top: 10%">
          <el-form ref="form" :model="loginform" label-width="80px">
            <el-form-item label="用户名">
              <el-input v-model="loginform.username"></el-input>
            </el-form-item>
            <el-form-item label="密码">
              <el-input v-model="loginform.password" show-password></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" style="width: 200px;" @click="onSubmit">登录</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div v-if="!loginFlag">
        <div style="width: 50%;height:1000px;float: left;background-color: #fafafa">
          <div style="margin-left: 5px;margin-top: 25px;margin-bottom: 25px">
            <el-switch
                style="width: 250px;"
                v-model="leftValue"
                active-text="开启左侧遥控"
                inactive-text="关闭左侧遥控">
            </el-switch>
          </div>
          <div style="display: flex;flex-direction: column; flex-wrap: wrap; align-content: flex-start;">
            <div v-for="item in leftTable" :key="item.value" @click="operate(2,item.value)" style="margin-left: 50px;margin-bottom: 30px;height: 80px; width: 120px;text-align: center;">
              <el-button style="height: 80px; width: 120px;background-color: #18aae1;font-size: 20px;font-weight: bold;color: #FFFFFF">
                {{ item.label }}
              </el-button>
            </div>
          </div>
        </div>
        <div style="width: 50%;height:1000px;float: left;background-color: #c9c9c9">
          <div style="margin-left: 5px;margin-top: 25px;margin-bottom: 25px">
            <el-switch
                style="width: 250px;"
                v-model="rightValue"
                active-text="开启右侧遥控"
                inactive-text="关闭右侧遥控">
            </el-switch>
          </div>
          <div style="display: flex;flex-direction: column; flex-wrap: wrap; align-content: flex-start;">
            <div v-for="item in rightTable" :key="item.value" @click="operate(1,item.value)" style="margin-left: 50px;margin-bottom: 30px;height: 80px; width: 120px;text-align: center;">
              <el-button style="height: 80px; width: 120px;background-color: #092a49;font-size: 20px;font-weight: bold;color: #FFFFFF">
                {{ item.label }}
              </el-button>
            </div>
          </div>
        </div>
      </div>

<!--        <div  style="padding: 50px">
          <el-switch
              v-model="rightValue"
              active-text="开启右侧遥控"
              inactive-text="关闭右侧遥控">
          </el-switch>
        </div>
        <div style="display: flex;flex-direction: column;justify-items: auto">
          <el-button v-for="item in rightTable" :key="item.value" @click="operate(1,item.value)" style="height: 80px; width: 120px;background-color: #092a49;font-size: 20px;font-weight: bold;color: #FFFFFF">
            {{ item.label }}
          </el-button>
        </div>-->

    </div>
</template>

<script>
    import { operationData } from "@/api/operationData";  // 后端登录接口
    export default {
      watch: {
        leftValue(newVal) {
          if (newVal) {
            this.form.start = '0'
          } else {
            this.form.start = '1'
          }
          this.operate(2, 1)
        },
        rightValue(newVal) {
          if (newVal) {
            this.form.start = '0'
          } else {
            this.form.start = '1'
          }
          this.operate(1, 1)
        }
      },
      data() {
            return {
              loginform: {
                username: '',
                password: ''
              },
              loginFlag: true,
              leftValue: true,
              rightValue: true,
              form: {  "id": 1,  "createUser": 0,  "createDept": 0,  "createTime": "",  "updateUser": 0,  "updateTime": "",  "status": 0,  "isDeleted": 0,  "value": "2008",  "remark": "",  "start": "1"},
              leftTable: [
                {
                  "label": "智慧校园",
                  "value": "1"
                },
                {
                  "label": "智慧出行",
                  "value": "2"
                },
                {
                  "label": "智慧医疗",
                  "value": "3"
                },
                {
                  "label": "肉牛产业",
                  "value": "4"
                },
                {
                  "label": "智慧物业",
                  "value": "5"
                },
                {
                  "label": "零工市场",
                  "value": "6"
                },
                {
                  "label": "矿产资源",
                  "value": "7"
                }
              ],
              rightTable:
                  [
                    {
                      "label": "生命纪念",
                      "value": "1"
                    },
                    {
                      "label": "大宗产业",
                      "value": "2"
                    },
                    {
                      "label": "建设工程",
                      "value": "3"
                    },
                    {
                      "label": "智慧停车",
                      "value": "5"
                    },
                    {
                      "label": "其他产业",
                      "value": "4"
                    }
                ],
              userToken:'', // 用于存储从后台获取的token
            };
        },
        methods:{
          onSubmit() {
            if ( this.loginform.username === 'tiancheng' && this.loginform.password === 'tiancheng' ) {
              this.loginFlag = false
            } else {
              this.$message.error('用户名或密码错误！！');
            }
          },
          operate(id,data){
            /* const form1 = {
                  "id": id,
                  "value": data,
                  "remark": '',
                  "is_deleted": '0'
                } */
                this.form.id = id
                this.form.value = data
            // 操作接口
            operationData(this.form)
              .then((res)=>{
                if(res.data.code === 200){
                  this.$message({
                    message: '操作成功',
                    type: 'success',
                    duration: 1
                  });
                }else{
                  this.$message.error("操作失败");
                }
            })
            .catch(err=>{
              this.$message.error(err);
                console.log(err);
            })
          }
        },
    };
</script>
